<div class="kp-flex-full-width-spacer"></div>

<style lang="less">
    .kp-flex-full-width-spacer {
        flex: 1;
    }
</style>